'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NitroSnackbar = function (_Component) {
  _inherits(NitroSnackbar, _Component);

  function NitroSnackbar(props) {
    _classCallCheck(this, NitroSnackbar);

    var _this = _possibleConstructorReturn(this, (NitroSnackbar.__proto__ || Object.getPrototypeOf(NitroSnackbar)).call(this, props));

    _this.handleClickAway = function () {
      if (_this.timerTransition || !_this.state.isOpen) {
        // Exit if transitioning or already closed
        return;
      }

      _this.close();
    };

    _this.open = function () {
      _this.setState({
        isOpen: true
      });
    };

    _this.close = function () {
      _this.setState({
        isOpen: false
      });

      if (typeof _this.props.onRequestClose === 'function') {
        _this.setTransitionTimer(_this.props.onRequestClose);
      }
    };

    _this.state = {
      message: props.message,
      isOpen: props.open
    };
    return _this;
  }

  _createClass(NitroSnackbar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.isOpen) {
        this.setAutoHideTimer();
        this.setTransitionTimer();
      }

      document.addEventListener('click', this.handleClickAway);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.state.isOpen && nextProps.open && (nextProps.message !== this.props.message || nextProps.action !== this.props.action)) {
        this.close();

        clearTimeout(this.timerOneAtTheTime);
        this.timerOneAtTheTime = setTimeout(function () {
          _this2.setState({
            message: nextProps.message,
            action: nextProps.action
          });

          _this2.open();
        }, this.props.transitionDuration);
        return;
      }

      this.setState({
        message: nextProps.message,
        action: nextProps.action
      });

      if (nextProps.open) {
        this.open();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.isOpen !== this.state.isOpen) {
        if (this.state.isOpen) {
          this.setAutoHideTimer();
          this.setTransitionTimer();
          return;
        }

        clearTimeout(this.timerAutoHide);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timerAutoHide);
      clearTimeout(this.timerTransition);
      clearTimeout(this.timerOneAtTheTime);

      this.handleClickAway();

      document.removeEventListener('click', this.handleClickAway);
    }
  }, {
    key: 'setAutoHideTimer',
    value: function setAutoHideTimer() {
      var _this3 = this;

      var autoHideDuration = this.props.autoHideDuration;

      if (autoHideDuration > 0) {
        clearTimeout(this.timerAutoHide);
        this.timerAutoHide = setTimeout(function () {
          _this3.close();
        }, autoHideDuration);
      }
    }

    // Helper function for transition callbacks

  }, {
    key: 'setTransitionTimer',
    value: function setTransitionTimer(cb) {
      var _this4 = this;

      this.timerTransition = setTimeout(function () {
        _this4.timerTransition = undefined;

        if (typeof cb === 'function') {
          cb();
        }
      }, this.props.transitionDuration);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          autoHideDuration = _props.autoHideDuration,
          contentStyle = _props.contentStyle,
          bodyStyle = _props.bodyStyle,
          onRequestClose = _props.onRequestClose,
          onActionTouchTap = _props.onActionTouchTap,
          props = _objectWithoutProperties(_props, ['autoHideDuration', 'contentStyle', 'bodyStyle', 'onRequestClose', 'onActionTouchTap']);

      var _state = this.state,
          action = _state.action,
          message = _state.message,
          isOpen = _state.isOpen;


      var actionButton = action && _react2.default.createElement(
        _styles.StyledSnackBarButton,
        { onClick: onActionTouchTap },
        action
      );

      return _react2.default.createElement(
        _styles.StyledSnackBar,
        _extends({ isOpen: isOpen }, props),
        _react2.default.createElement(
          _styles.StyledSnackbarBody,
          _extends({ action: action, isOpen: isOpen }, props),
          _react2.default.createElement(
            'span',
            null,
            message
          ),
          actionButton
        )
      );
    }
  }]);

  return NitroSnackbar;
}(_react.Component);

NitroSnackbar.propTypes = {
  action: _propTypes2.default.string,
  autoHideDuration: _propTypes2.default.number,
  backgroundColor: _propTypes2.default.string,
  bodyStyle: _propTypes2.default.object,
  borderRadius: _propTypes2.default.string,
  className: _propTypes2.default.string,
  contentStyle: _propTypes2.default.object,
  height: _propTypes2.default.string,
  lineHeight: _propTypes2.default.string,
  maxWidth: _propTypes2.default.string,
  message: _propTypes2.default.node,
  minWidth: _propTypes2.default.string,
  onActionTouchTap: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  open: _propTypes2.default.bool,
  sidePadding: _propTypes2.default.string,
  textColor: _propTypes2.default.string,
  transitionDuration: _propTypes2.default.number
};

NitroSnackbar.defaultProps = {
  backgroundColor: 'rgba(10, 10, 10, .85)',
  borderRadius: '3px',
  height: '50px',
  lineHeight: '50px',
  maxWidth: '568px',
  minWidth: '288px',
  sidePadding: '24px',
  textColor: 'white',
  transitionDuration: 400
};

exports.default = NitroSnackbar;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-snackbar/NitroSnackbar.js
// module id = 3037
// module chunks = 4